<nh-form
  [individuals]="individuals"
  [formGroup]="getForm()"
  [mode]="mode"
  (validate)="onValidate($event)"
>
  @if (invaidRelation || invaidRelationOutside) {
  <div>
    <nh-alert type="danger" [isOpen]="invaidRelation || invaidRelationOutside">
      <div class="row">
        <div class="col-auto icon">
          <img
            src="../../../../../assets/images/Icons/⚛️ icons-alert-circle-outline.svg"
            alt=""
          />
        </div>
        <div class="col message">
          <span>{{ invalidRel }}</span>
        </div>
      </div>
    </nh-alert>
  </div>
  } @if (invalidUnknownGenderRelation) {
  <div>
    <nh-alert type="danger" [isOpen]="invalidUnknownGenderRelation">
      <div class="row">
        <div class="col-auto icon">
          <img
            src="../../../../../assets/images/Icons/⚛️ icons-alert-circle-outline.svg"
            alt=""
          />
        </div>
        <div class="col message">
          <span>{{ unknownGenderRelationError }}</span>
        </div>
      </div>
    </nh-alert>
  </div>
  }
  <div>
    <h1 class="section-header">Relationships</h1>
    <hr />
    <p>Please tell us how the people in the home are related to each other.</p>
    <section [formGroup]="getControl('data')">
      <div [formGroup]="getControl('data.householdRelationshipInformation')">
        <table class="table w-100 table-striped">
          <thead>
            <tr>
              <th scope="col">First Person</th>
              <th scope="col">Relationship</th>
              <th scope="col">Second Person</th>
              <th scope="col">Primary Caregiver</th>
              <th scope="col">Joint filers</th>
            </tr>
          </thead>
          <tbody formArrayName="relationshipList">
            @for (row of relationshipList.controls; track row; let i = $index;
            let isLast = $last) {
            <tr [formGroupName]="i">
              <td>
                {{ name(row.value.sourceIndividual) }},
                {{ age(row.value.sourceIndividual) }}
                {{ fetchGender(row.value.sourceIndividual) }}
              </td>
              <td>
                <nh-field
                  [isRow]="true"
                  [mandatory]="false"
                  [attr.aria-required]="false"
                  class="label-section"
                >
                  <select
                    aria-label="relation"
                    nh
                    name="relation"
                    formControlName="relation"
                    aria-required="true"
                    [items]="
                      tables[
                        gender(
                          getControl(
                            'data.householdRelationshipInformation.relationshipList'
                          ),
                          i
                        )
                      ]
                    "
                    (change)="
                      onRelationChange('relationshipList', row, i, true)
                    "
                  ></select>
                  @if (isDuplicateRelation(i)) {
                  <span class="form-text invalid-name d-block"
                    >One individual cannot have more than one spouse</span
                  >
                  } @if (isParentRelationError(i) && !isDuplicateRelation(i)) {
                  <span class="form-text invalid-name d-block">{{
                    parentRelationError
                  }}</span>
                  } @if (isYoungerParent(i) && !isParentRelationError(i) &&
                  !isDuplicateRelation(i)) {
                  <span class="form-text invalid-name d-block">{{
                    "PARENT_GRANDPARENT_ERROR" | translate
                  }}</span>
                  }
                </nh-field>
              </td>
              <td>
                {{ name(row.value.referenceIndividual) }},
                {{ age(row.value.referenceIndividual) }}
                {{ fetchGender(row.value.referenceIndividual) }}
              </td>
              <td>
                @if (getPrimaryCare(row?.value?.relation?.code) &&
                !row?.value?.isReverseFlow) {
                <nh-checkbox
                  [name]="'primaryCaregiver_' + i"
                  (change)="primaryCaregivers(relationshipList)"
                  [control]="$any(row).controls.primaryCaregiver"
                  [checkedValue]="val"
                  class="label-section"
                  [id]="'primaryCaregiver-' + i"
                  [ariaLabel]="
                    'Primary Caregiver for ' +
                    name(row.value.referenceIndividual)
                  "
                >
                </nh-checkbox>
                }
              </td>
              <td>
                @if (getJointFiler(row?.value?.relation?.code) &&
                !row?.value?.isReverseFlow) {
                <nh-checkbox
                  [name]="'jointFilers_' + i"
                  [control]="$any(row).controls.jointFilers"
                  [checkedValue]="val"
                  class="label-section"
                  [id]="'jointFilers-' + i"
                  [ariaLabel]="
                    'Joint Filers for ' +
                    name(row.value.sourceIndividual) +
                    ' and ' +
                    name(row.value.referenceIndividual)
                  "
                >
                </nh-checkbox>
                }
              </td>
            </tr>
            }
            <tr>
              @if (ifRequired) {
              <span class="invalid-name d-block"
                >You can only select up to two primary caretakers per
                child.</span
              >
              }
            </tr>
          </tbody>
        </table>
        <br />
        <div hidden>
          <h2 class="section-header">Primary Caregiver</h2>
          <hr />
          <!-- <div (click)="showPrimaryCaregiverModal()" [style.color]="'#2274aa'">More about Primary Caregivers
                <span><i class="fa fa-external-link" aria-hidden="true"></i></span>
              </div> -->

          <div class="row ps-1 pt-1 hover-red">
            <a
              class="btn btn-link hover-red"
              (click)="showPrimaryCaregiverModal()"
            >
              <span class="pe-2">More about Primary Caregivers</span>
              <span
                ><i class="fa fa-external-link" aria-hidden="true"></i
              ></span>
            </a>
          </div>

          <br />
          <div formArrayName="primaryCareList">
            <ng-container>
              <table class="row g-3">
                <tr class="w-100 row">
                  <th class="col-3 col-md-3">First Person</th>
                </tr>
                @for (primaryCareList of primaryCareList.controls; track
                primaryCareList; let i = $index) {
                <tr class="w-100">
                  <fieldset [formGroupName]="i" class="w-100 row">
                    <td class="col-3 col-md-3">
                      {{ name(primaryCareList.value.indvId) }}
                    </td>
                  </fieldset>
                </tr>
                }
              </table>
            </ng-container>
          </div>
        </div>
      </div>
      <br />
      @if (taxFilersEnabled) {
      <div>
        <h2 class="section-header">Tax Dependents in the Household</h2>
        <hr />
        @if (error.isError) {
        <div class="small alert alert-danger">
          {{ error.errorMessage }}
        </div>
        }
        <table class="table w-100 table-striped">
          <thead>
            <tr>
              <th scope="col">Person claiming a dependent</th>
              <th scope="col">Person being claimed as a dependent</th>
              <th scope="col">
                <span class="visually-hidden">Actions</span>
              </th>
            </tr>
          </thead>
          <tbody formArrayName="taxFilingData">
            @for (row of taxFilingData.controls; track row; let i = $index; let
            isLast = $last) {
            <tr [formGroupName]="i">
              <td>
                <nh-field
                  [isRow]="true"
                  [mandatory]="false"
                  [attr.aria-required]="false"
                  class="label-section"
                >
                  <select
                    aria-label="taxFilingIndividualId"
                    nh
                    [attr.disabled]="
                      taxFilingData.controls[i].value.taxFilingIndividualId !=
                      null
                        ? true
                        : null
                    "
                    name="taxFilingIndividualId"
                    formControlName="taxFilingIndividualId"
                    bindValue="individualId"
                    bindLabel="name"
                    [items]="getTaxFilers(true)"
                    (change)="onTaxChange($event, i)"
                  ></select>
                </nh-field>
              </td>
              <td>
                <nh-field
                  [isRow]="true"
                  [mandatory]="false"
                  [attr.aria-required]="false"
                  class="label-section"
                >
                  <select
                    aria-label="taxDependentIndividualId"
                    nh
                    name="taxDependentIndividualId"
                    formControlName="taxDependentIndividualId"
                    bindValue="individualId"
                    bindLabel="name"
                    [items]="getTaxFilers(false)"
                    (change)="onTaxChange($event, i)"
                  ></select>
                  @if (isDuplicateTaxDependent(i)) {
                  <span class="invalid-name d-block"
                    >You have listed the same tax dependent for
                    {{ taxDependentName[i] }} more than once. Please update the
                    tax dependent entry for {{ taxDependentName[i] }} before
                    continuing.</span
                  >
                  }
                </nh-field>
              </td>
              <td>
                <div class="hover-red">
                  <button
                    class="btn btn-link btn-lg delete-{{ i }} hover-red p-1"
                    (click)="removeAt(i, row)"
                  >
                    <span class="pe-2">Remove</span>
                    <nh-remove-svg></nh-remove-svg>
                  </button>
                </div>
              </td>
            </tr>
            }
          </tbody>
        </table>
        <div class="pt-1 hover-red text-start">
          <button class="btn btn-link btn-lg hover-red" (click)="addRow()">
            <span class="pe-2">Add Another</span>
            <nh-add-svg></nh-add-svg>
          </button>
        </div>
      </div>
      }
      <br />
      <h2 class="section-header">
        Tax Dependents / Joint Filers Outside the Household
      </h2>
      <hr />
      @if (errorRelationSPO.isError) {
      <div class="small alert alert-danger">
        {{ errorRelationSPO.errorMessage }}
      </div>
      }
      <table class="table w-100 table-striped" style="margin-bottom: 5px">
        <thead>
          <tr>
            <th scope="col">Person Name</th>
            <th scope="col">Relationship</th>
            <th scope="col">First Name</th>
            <th scope="col">Last Name</th>
            <th scope="col">Date of Birth</th>
            <th scope="col">Tax Dependents</th>
            <th scope="col">Joint Filer</th>
            <th scope="col">
              <span class="visually-hidden">Actions</span>
            </th>
          </tr>
        </thead>
        <tbody formArrayName="outsideHousehold">
          @for (row of outsideHousehold.controls; track row; let i = $index; let
          isLast = $last) {
          <tr [formGroupName]="i">
            <td>
              <nh-field
                [isRow]="true"
                [mandatory]="false"
                [attr.aria-required]="false"
              >
                <select
                  aria-label="taxFilerIndividual"
                  nh
                  name="taxFilerIndividual"
                  style="width: 140px !important"
                  [attr.disabled]="
                    outsideHousehold.controls[i].value.taxFilerIndividual !=
                    null
                      ? true
                      : null
                  "
                  formControlName="taxFilerIndividual"
                  bindValue="individualId"
                  bindLabel="name"
                  [items]="getTaxFilers(true)"
                  (change)="onTaxFilingChange('household', row, i)"
                ></select>
              </nh-field>
            </td>
            <td>
              <select
                aria-label="relation"
                nh
                name="relation"
                formControlName="relation"
                style="width: 140px !important; margin-bottom: 16px"
                [items]="tables[gender(getControl('data.outsideHousehold'), i)]"
                (change)="relationChange(row, i)"
              ></select>
            </td>
            <td>
              <nh-field
                [isRow]="true"
                [mandatory]="false"
                [attr.aria-required]="false"
              >
                <input
                  aria-label="dependentFirstName"
                  type="text"
                  name="dependentFirstName"
                  maxlength="22"
                  (change)="onRelationChange('household', row, i, false)"
                  formControlName="dependentFirstName"
                  label="dependentFirstName"
                  class="form-control setWidth"
                />
              </nh-field>
            </td>
            <td>
              <nh-field
                [isRow]="true"
                [mandatory]="false"
                [attr.aria-required]="false"
              >
                <input
                  aria-label="dependentLastName"
                  type="text"
                  name="dependentLastName"
                  maxlength="22"
                  (change)="onRelationChange('household', row, i, false)"
                  formControlName="dependentLastName"
                  label="dependentLastName"
                  class="form-control setWidth"
                />
              </nh-field>
            </td>
            <td style="width: 165px !important">
              <nh-field
                [isRow]="true"
                [mandatory]="false"
                [attr.aria-required]="false"
              >
                <nh-datepicker>
                  <input
                    aria-label="dependentBirthDate"
                    type="text"
                    name="dependentBirthDate"
                    class="form-control"
                    (change)="onRelationChange('household', row, i, false)"
                    formControlName="dependentBirthDate"
                    [minDate]="minimumDate"
                    [maxDate]="today"
                    bsDatepicker
                    nh
                  />
                </nh-datepicker>
              </nh-field>
            </td>
            <td>
              @if (getDependent(row?.value?.hasTaxDependentOutside?.code) ||
              getJointFiler(row?.value?.relation?.code)) {
              <nh-checkbox
                uniqueString="taxDependent"
                [disabled]="hasDependent && !row?.value?.taxDependent?.code"
                name="taxDependent"
                [control]="$any(row).controls.taxDependent"
                (change)="onRelationChange('household', row, i, false)"
                [checkedValue]="val"
                label=""
              >
              </nh-checkbox>
              }
            </td>
            <td>
              @if (getJointFiler(row?.value?.relation?.code) &&
              !errorRelationSPO.isError) {
              <nh-checkbox
                uniqueString="jointFiler"
                [disabled]="
                  (hasJointFiler && !row?.value?.relation?.code) ||
                  errorRelationSPO.isError
                "
                name="jointFiler"
                [control]="$any(row).controls.jointFiler"
                (change)="onRelationChange('household', row, i, false)"
                [checkedValue]="val"
                label=""
              >
              </nh-checkbox>
              }
            </td>
            <td>
              <div class="pt-1 hover-red">
                <button
                  class="btn btn-link btn-lg delete-{{ i }} hover-red p-1"
                  (click)="removeTaxDependentAt(i, row)"
                >
                  <span class="pe-2">Remove</span>
                  <nh-remove-svg></nh-remove-svg>
                </button>
              </div>
            </td>
          </tr>
          }
        </tbody>
      </table>
      <div
        style="width: 450px"
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
      >
        @if (isRequired) {
        <span class="invalid-name d-block"
          >You have started providing information about a tax dependent or joint
          filer outside the household. Please provide the rest of the
          information asked in this row of the table.</span
        >
        }
      </div>
      <div class="pt-1 hover-red text-start">
        <button
          class="btn btn-link btn-lg hover-red"
          (click)="addTaxDependentsRow()"
        >
          <span class="pe-2">Add Another</span>
          <nh-add-svg></nh-add-svg>
        </button>
      </div>
      <div>
        <input type="hidden" formControlName="hiddenField" />
      </div>
      <div>
        <input type="hidden" formControlName="hiddenRelationField" />
      </div>
    </section>
  </div>
</nh-form>